import React from 'react';
import * as PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import TextColumns from './TextColumns';
import styleConstants from '../../../styleConstants';

const useStyles = makeStyles({
	container: {
		//display: 'flex',
		//alignItems: 'center'
		paddingBottom: styleConstants.componentSpacing
	},
	content: {
		padding: '4rem 2rem 0'
	}
});

const LargeFigure = props => {
	const classes = useStyles(props);

	return (
		<div className={classes.container}>
			<div>{props.figure}</div>
			<div className={classes.content}>
				<TextColumns>{props.children}</TextColumns>
			</div>
		</div>
	);
};

LargeFigure.propTypes = {
	figure: PropTypes.node.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	])
};

export default LargeFigure;
